module.exports = {"pagination":{"defaultPage":1,"defaultRowsPerPage":10,"rowsPerPageItems":[10,20,30,50,100]}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 85
// module chunks = 0